import {
    CreateRequest,
    GetLink,
    Http,
    RequestMethod,
    Resource,
    UseCase,
    ReplaceParams
} from '@mdd/api';

export namespace CreateResource {
    export interface Params<T> {
        resource?: T;
        parent: Resource<string>;
        rel: string;
        queryParams?: object;
        method?: RequestMethod;
    }
}

export class CreateResource<T> implements UseCase<CreateResource.Params<T>, Promise<T>> {
    private getLink = new GetLink<string>();
    private createRequest = new CreateRequest();
    private replaceParams = new ReplaceParams<string>();

    constructor(private http: Http) {}

    execute({ resource, parent, rel, queryParams, method }: CreateResource.Params<T>): Promise<T> {
        let link = this.getLink.execute({ parent, rel })!.href;
        if (queryParams) {
            link = this.replaceParams.execute({ link, queryParams });
        }

        if (resource) {
            return this.http
                .request<T, T>(
                    this.createRequest.execute({
                        method: method || 'POST',
                        url: link,
                        body: resource
                    })
                )
                .then((response) => response.body!);
        } else {
            return this.http
                .request<void, T>(
                    this.createRequest.execute({
                        method: method || 'POST',
                        url: link
                    })
                )
                .then((response) => response.body!);
        }
    }
}
